input{padding:0 11px;border:1px solid #d9d9d9;height:32px}.abg-submitted .abg.ng-invalid,.reactions-submitted .reaction.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=arterial-blood-gas-add-edit.component-IGR5BMDN.css.map */
